// Parse complete SSE frames; a UTF-8 codepoint, CRLF or JSON object may span network chunks.
export async function parseSseStream(body, onEvent) {
  if (!body) throw new Error('Streaming is unavailable in this browser.')
  const reader = body.getReader()
  const decoder = new TextDecoder()
  let buffer = '', doneEvent = false
  const frame = raw => {
    let name = 'message'
    const data = []
    raw.split('\n').forEach(line => {
      if (line.startsWith('event:')) name = line.slice(6).trim()
      if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''))
    })
    if (!data.length) return
    const value = JSON.parse(data.join('\n'))
    if (name === 'done') doneEvent = true
    onEvent(name, value)
  }
  try {
    while (true) {
      const { value, done } = await reader.read()
      buffer += done ? decoder.decode() : decoder.decode(value, { stream: true })
      // Normalize only complete CRLF pairs, leaving a trailing CR for the next chunk.
      buffer = buffer.replace(/\r\n/g, '\n')
      let boundary
      while ((boundary = buffer.indexOf('\n\n')) >= 0) {
        frame(buffer.slice(0, boundary)); buffer = buffer.slice(boundary + 2)
      }
      if (buffer.length > 300000) throw new Error('The reply exceeded the streaming limit.')
      if (done) break
    }
    if (buffer.trim()) frame(buffer)
    if (!doneEvent) throw new Error('The connection ended before the reply completed.')
  } finally {
    // Close the HTTP body on parser/consumer failure so the server cancels its generation.
    await reader.cancel().catch(() => {})
    reader.releaseLock()
  }
}
